import React, {useMemo, useState} from 'react';
import Component from "../../../components/Component";
import Select from "react-select";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {useAPI} from "../../../config/API";

const {Option, OptGroup} = Select;


const ProjectFilterDropdown = (props) => {

    const [value, setValue] = useState('');
    const {
        data,
        isInitialLoading: isLoading,
        isFetching,
        error
    } = useAPI(['searchProjectKeywords', value], {
        enabled: String(value).length > 0,
        initialData: props.initValues,
    })

    const handleChange = async (opt, ...args) => {
        console.log('handleChange', opt, args)
        await onInputChange('', {action: 'input-change'});

        if (Array.isArray(opt)) {
            await props.onChange(opt)
        }
    };

    const options = useMemo(() => {

        return TB.map(data || [], ({key, title, results}) => {
            return {
                label: title,
                value: key,
                options: results.map(result => {
                    return {
                        label: result.name,
                        value: key + '-' + result.id,
                        ...result,
                        type: key
                    }
                })
            }

        })
    }, [data, isLoading]);

    const onInputChange = async (inputValue, {action}) => {
        switch (action) {
            case 'input-change':
                if (action === 'input-change' && value !== inputValue) {
                    await setValue(inputValue)
                    if (props.onSearch) {
                        props.onSearch(inputValue || '')
                    }
                }
                break;
        }
    }
    return (
        <Select
            showSearch
            searchValue={value}
            isMulti
            placeholder={props.placeholder}
            disabled={props.isDisabled}
            defaultActiveFirstOption={false}
            filterOption={false}
            onInputChange={onInputChange}
            onChange={handleChange}
            isLoading={isFetching}
            inputValue={value}
            isDisabled={props.isDisabled}
            options={options}
            noOptionsMessage={() => isFetching ? (
                <LoadingSpinner size="sm"/>
            ) : (value?.length > 0 ? 'No options' : 'Search to view results')}
        />
    )
}
export default class StatusFilterDropdown extends Component {

    constructor(props) {
        super(props);

        this.state = {
            searchQuery: '',
            values: props.initValues || []
        };
    }

    onChange = async (opt) => {

        if (this.state.values === opt) {
            return
        }

        await this.promisedState({
            values: opt,
            searchQuery: ''
        });

        this.props.onChange(this.state.values)
    };

    onInputChange = async (value, {action}) => {
        switch (action) {
            case 'input-change':
                if (action === 'input-change' && this.state.searchQuery !== value) {
                    this.setState({searchQuery: value || ''}, () => {
                        if (this.props.onSearch) {
                            this.props.onSearch(value || '')
                        }
                    });
                }
                break;
        }
    }

    render() {
        return (
            <div className={this.props.className || "opp-filter-dropdown"}>
                <Select
                    placeholder={this.props.placeholder}
                    options={this.props.options}
                    isMulti
                    noOptionsMessage={() => {
                        return this.props.noOptionsMessage || 'No options';
                    }}
                    onInputChange={this.onInputChange}
                    isLoading={this.props.isLoading}
                    inputValue={this.state.searchQuery}
                    isDisabled={this.props.isDisabled}
                    value={this.state.values}
                    onChange={this.onChange}
                />
            </div>
        );
    }
}

export {
    ProjectFilterDropdown
};